import { LabelStyles } from '@tableau/catalog-ui-temp';
import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import { Tooltip, TooltipPosition } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

const VISIBILITY_NA = '-';

export function LabelVisibilityCell(labelCategoryPropName: string, isSeverePropName: string, testId?: string, styleOverride?: React.CSSProperties): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function LabelValueCell(props: BodyCell.Props) {
      const labelCategory = props.row.data[labelCategoryPropName];
      const labelVisibility = props.row.data[isSeverePropName];
      const labelVisibilityMsg = showVisibilityLevel(labelCategory, labelVisibility);
      return (
        <div style={CommonStyles.Layout.FlexBlockVerticalCenter}>
          <span style={LabelStyles.visibilityTextStyle}>{labelVisibilityMsg}</span>
          {showTooltip(labelCategory, labelVisibilityMsg) &&
            <Tooltip
              tooltipContent={Messages.labelVisibilityTooltipMsg()}
              position={TooltipPosition.BottomRightCorner}
              followCursor={false}
              maxWidth={400}
            >
              <NotificationInfoOutlineIcon size={16} alt={''} />
            </Tooltip>}
        </div>);
    },
    styleOverride
  );
}

function showVisibilityLevel(labelCategory: string, labelVisibility: boolean): string {
  // Only show visiblity message for sensitivity and warning. 
  // Certification and custom categoreis don't have visiblity
  if (labelCategory === 'SENSITIVITY' || labelCategory === 'WARNING') {
    return labelVisibility ? Messages.labelVisibilityHigh() : Messages.labelVisibilityStandard();
  }
  return VISIBILITY_NA;
}

function showTooltip(labelCategory: string, labelVisibility: string): boolean {
  // Don't show tooltip when the category is sensitivity or when visiblity has no value
  return labelCategory !== 'SENSITIVITY' && labelVisibility !== VISIBILITY_NA;
}